import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventActionEnum, EventCategoryEnum } from '@app/core/services/analytics';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AccountService, AuthService } from '@core/services';

import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';

import { User, UserProfileVerificationEnum } from 'lingo2-models';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { filter, map, takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-come-visit-banner',
  templateUrl: './come-visit-banner.component.html',
  styleUrls: ['./come-visit-banner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocaleSharedModule, CommonModule, LazyLoadImageModule],
})
export class ComeVisitBannerComponent extends AbstractPane implements OnInit {
  private readonly accountService = inject(AccountService);
  errorNotificationService = inject(ErrorNotificationService);
  private authService = inject(AuthService);

  private me: User;
  private verification_status: UserProfileVerificationEnum;

  ngOnInit(): void {
    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        this.me = me;
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });

    this.contextService.profile$
      .pipe(
        filter((x) => !!x),
        map((x) => x.verification_status),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (verification_status) => {
          this.verification_status = verification_status;
          this.markForCheck();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  hasContent(): boolean {
    return true;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  /** пометить меня как 'хочу стать преподом' */
  public becomeTeacher() {
    this.analytics.event(EventActionEnum.become_teacher, EventCategoryEnum.engagement, `app-come-visit-banner`);
    this.accountService
      .markAsTeacher()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (account) => {
          this.contextService.updateMe(account);
          this.router.navigateByUrl('/me/teacher').then(() => true);
        },
        error: (error: any) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.router.navigateByUrl('/teachers').then(() => true);
        },
      });
  }

  public get isTeacher(): boolean {
    return AccountService.isAsIfTeacher(this.me);
  }

  public authorize() {
    this.authService.showAuthModal();
  }

  public isAuthenticated() {
    return this.authService.isAuthenticated;
  }

  public isVerified() {
    return this.verification_status === UserProfileVerificationEnum.approved;
  }
}
